import { createSelector } from '@reduxjs/toolkit';

import { configBaseSelector } from './leadAttributesSelector';

export const salesGroupMapSelector = createSelector(
  configBaseSelector,
  (configDetails) => configDetails.salesGroups,
);
